import { ValueFormatterParams } from "ag-grid-community";
import React, { useCallback, useMemo, useRef, useState } from "react";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import { ColumnDef } from "../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../components/ModalDelete";
import Loading from "../../../../core/common/Loading";
import { useModal } from "../../../../hooks/ModalContext";
import api from "../../../../services/api";
import Create from "./Create";
import { IParametro } from "./Create/types/types";
import Info from "./Info";
import Can from "../../../../components/Can";

// import { Continer } from './styles';

const ListParametros: React.FC = () => {


  const columns = useMemo<ColumnDef[]>(() => [
    {
      field: "chave",
      headerName: "Chave",
      flex: 1,
      filter: true,
      sortable: true,
    },
    {
      field: "valor",
      headerName: "Valor",
      flex: 1,
      filter: true,
      sortable: false,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 1,
      filter: true,
      sortable: false,
    },
    {
      field: "unidade",
      headerName: "Unidade",
      flex: 1,
      filter: true,
      sortable: false,
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
  ], []);

  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRow, setSelectedRows] = useState<IParametro>();
  const [isView, setIsView] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const gridRef = useRef<any>();

  const { isModalOpen, closeModal, openModal } = useModal();

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);
      const body = {
        id_configuracao_parametros: rowId,
      };

      await api.post("/deletar/configuracaoParametros", body);

      setLoading(false);

      setIsRemove(false);

      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, []);

  return (
    <>
      {isModalOpen && (
        <Create
          isView={isView}
          isEdit={isEdit}
          selectedRow={selectedRow}
          onClear={() => {
            closeModal();
            setIsEdit(false);
          }}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}

      <Loading loading={loading} />

      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => onDelete(selectedRow?.id_parametro)}
          row={`Parâmetro - ${selectedRow?.chave}`}
        />
      )}
      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Parâmetro"
          onClose={() => setIsView(!isView)}
        />
      )}

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">
              Parâmetros
            </h1>
          </div>
          <div className="mr-14">
            <Can acao="SALVAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
              onClick={() => openModal()}
              id="btnCreate"
            >
              Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
            </button>
            </Can>
          </div>
        </div>
        <div className="flex w-full">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            perPage={10}
            path="/listar/configuracaoParametros"
            status={[]}
            defaultSortField="id_parametro"
            onDelete={(data: any) => {
              setIsRemove(!isRemove);
              setSelectedRows(data);
            }}
            onView={(data: any) => {
              setSelectedRows(data);
              setIsView(!isView);
            }}
            onUpdate={(data: any) => {
              setSelectedRows(data);
              setIsEdit(!isEdit);
              openModal();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ListParametros;

